import Flex from '@deprecated-ui/common/Flex';
import Avatar from '@deprecated-ui/common/Avatar';
import color from '@deprecated-ui/_style/color';
import Link from 'next/link';
import { LabelAdmin, LabelVerifiedAccount } from 'global/Labels';
import Image from 'global/Image';
import { AVATAR_URL } from 'constants/api';
import { handleErrorAvatar } from 'utils/general';
import TextContent from '../TextContent';
import { CommentContainer, TextHeader } from './styled';
import { StreamPostData } from '../../../../@types/stream';

interface CommentProps {
  comment: StreamPostData;
  [key: string]: any;
}

function Comment({ comment, ...props }: CommentProps) {
  const {
    avatar,
    content,
    mask_html: maskedHtml,
    username,
    created_display: created,
    official,
    is_verified: isVerified,
    user_priv: privilege,
  } = comment;
  const avatarUrl = avatar.startsWith('http')
    ? avatar
    : `${AVATAR_URL}/${avatar}`;

  // Note :
  // From backend in stream post the type of official param is number
  // but stream post inside the last_reply have official param type string
  const isOfficial = official > 0 || isVerified;

  return (
    <div {...props} style={{ cursor: 'pointer' }}>
      <CommentContainer>
        {/* @ts-expect-error */}
        <Flex mb="10px">
          <Avatar size="x-small" padding="0 10px 0 0">
            <Image
              alt="imageProfile"
              src={avatarUrl}
              onError={(e) => handleErrorAvatar(e, username)}
            />
          </Avatar>
          <div>
            <Flex align="center">
              <Link href={`/${username}`}>
                <TextHeader family="bold" size="14px">
                  {username}
                </TextHeader>
              </Link>
              <LabelVerifiedAccount
                deprecatedVerifiedStatus={isOfficial}
                verifiedStatus={comment?.verified_status}
              />
              <LabelAdmin privilege={privilege} />
            </Flex>
            <TextHeader size="12px" color={color.midgray}>
              {created}
            </TextHeader>
          </div>
        </Flex>
        <TextContent
          content={content}
          maskedHtml={maskedHtml}
          style={{ marginBottom: '0px' }}
          needParsed={false}
        />
      </CommentContainer>
    </div>
  );
}

export default Comment;
